import { Repository } from '../repository';
import { type Tactic } from './entity';

export class Tactics extends Repository<Tactic> {
    private readonly prefix = 'CTA';

    getByTechniqueId(techniqueId: string): Tactic[] {
        return this.items.filter((tactic) =>
            tactic.techniqueIds.includes(techniqueId),
        );
    }

    getNextLabel(): string {
        const customItems = this.items.filter((tactic) => tactic.isCustom);
        const lastCustomItem = customItems[customItems.length - 1];
        if (!lastCustomItem) {
            return `${this.prefix}00001`;
        }
        const nr = parseInt(
            lastCustomItem.label?.slice(this.prefix.length) ?? '0',
        );
        const newNr = nr + 1;
        return `${this.prefix}${newNr.toString().padStart(5, '0')}`;
    }
}
